import { Component, OnInit, Input } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';
import { Observable } from 'rxjs';
import { DonneReferenceService } from '../../services/donne-reference.service';
import { OpenModalService } from '../../services/open-modal/open-modal.service';
import { ToolPreautorisationService } from '../../../tool-preautorisation/tool-preautorisation.service';

@Component({
  selector: 'app-content-preautorisation-acceptee-dashboard',
  templateUrl: './content-preautorisation-acceptee-dashboard.component.html',
  styleUrls: ['./content-preautorisation-acceptee-dashboard.component.scss'],
  standalone: false
})
export class ContentPreautorisationAccepteeDashboardComponent implements OnInit {
  langue = 'fr';
  telephoneSansFrais = '';
  telephoneMontreal = '';
  nomMembre = '';

  preautAmount$: Observable<number> = this._toolPreautorisationService.preautAmount$;
  isPreautExpiringSoon$: Observable<boolean> = this._toolPreautorisationService.isPreautExpiringSoon$;
  lastDayBeforeExpirationPreautEnLigne$: Observable<Date> = this._toolPreautorisationService
    .lastDayBeforeExpirationPreautEnLigne$;
  isRateExpiringSoon$: Observable<boolean> = this._toolPreautorisationService.isRateExpiringSoon$;
  dateExpirationTaux$: Observable<Date> = this._toolPreautorisationService.dateExpirationTaux$;
  isCoemprunteur$: Observable<boolean> = this._toolPreautorisationService.isCoemprunteur$;

  @Input()
  isDefaultBtnColor = true;

  constructor(
    private readonly _appConfigService: AppConfigService,
    private readonly _donneeReferencesService: DonneReferenceService,
    private readonly _openModalService: OpenModalService,
    private readonly _toolPreautorisationService: ToolPreautorisationService
  ) {}

  ngOnInit() {
    this.langue = this._appConfigService.configData.contexteEnvironnement.langue;
    this.telephoneSansFrais = this._donneeReferencesService.numerosDemandeSupport.sansFrais;
    this.telephoneMontreal = this._donneeReferencesService.numerosDemandeSupport.montreal;
    this.nomMembre = this._appConfigService.configData.personne.prenom;
  }

  openCancelModal() {
    this._openModalService.openModalCancelPreapproval(false);
  }
}
